<div>
    <img #logoImage [src]="logoUrl()" alt="Logo" class="logo-image"
        crossorigin="anonymous">
</div>
@if (this.auth.isAuthenticated()){

<div class="mb-2">
    <h4>Tracking de guías</h4>
    <div class="small">Muestra el estado de una guía</div>
</div>
}

@if (this.auth.isAuthenticated()){
<div class="row mt-2">
    <div class="col">
        <button type="button" (click)="goBack()" class="btn btn-outline-secondary">Volver</button>
    </div>
</div>
}
<div class="row">

    <div class="col-lg-6 col-xs-12 mt-2">
        <label for="nombre" class="form-label  ">Tracking</label>
        <div class="input-group">
            <input type="number" class="form-control" id="nro" [appAutofocus]="true"
                [(ngModel)]="tracking"
                placeholder="Ingrese el nro de tracking"
                name="nro">
            <button type="submit" class="ms-2 btn btn-primary" (click)="search()">Buscar</button>
        </div>
    </div>
    @if (guia.resource.statusCode() == 404) {
    <div class="alert alert-danger mt-2">
        No se encontró la guía.
    </div>
    }
    <div>
        <table class="table table-bordered table-hover mt-4">
            <thead>
                <tr>
                    <th style="width:70%">Direccion</th>
                    <th>Bultos</th>
                    <th>Tipo</th>
                </tr>
            </thead>
            @if (guia.resource.hasValue()){
            <tbody>
                <tr>
                    <td>{{guia.resource.value().direccionDestinatario}}</td>
                    <td>
                        @if ( guia.resource.value().bultosRecibidos != guia.resource.value().bultos){
                        {{guia.resource.value().bultosRecibidos}} / {{guia.resource.value().bultos}}
                        }
                        @else{
                        {{guia.resource.value().bultos}}
                        }
                    </td>
                    <td>{{guia.resource.value().tipoGuia}}</td>
                </tr>
            </tbody>
            }
        </table>
        <table class="table table-bordered table-hover mt-4">
            <thead>
                <tr>
                    <th style="width:200px">Fecha</th>
                    <th>Estado</th>
                </tr>
            </thead>
            @if (guia.resource.hasValue()){
            <tbody>
                @for(event of guia.resource.value().details; track event.guiaEstadoId) {
                <tr>
                    <td>{{event.fecha | date:'dd/MM/yyyy HH:mm'}}</td>
                    <td>{{event.estado}}</td>
                </tr>
                @if (event.foto || event.firma) {
                <tr class="tracking-details-row">
                    <td colspan="2" class="py-3">
                        <details class="tracking-media-details">
                            <summary>Ver evidencia</summary>
                            <div class="row g-3 mt-3">
                                @if (event.foto) {
                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100 bg-light-subtle">
                                        <div class="fw-semibold mb-2">Foto</div>
                                        <img
                                            [src]="'data:' + (event.foto.contentType || 'image/png') + ';base64,' + event.foto.contenido"
                                            [alt]="'Foto asociada al estado ' + event.estado"
                                            class="img-fluid rounded border">
                                    </div>
                                </div>
                                }
                                @if (event.firma) {
                                <div class="col-md-6">
                                    <div class="border rounded p-3 h-100 bg-light-subtle">
                                        <div class="fw-semibold mb-2">Firma</div>
                                        <img
                                            [src]="'data:' + (event.firma.contentType || 'image/png') + ';base64,' + event.firma.contenido"
                                            [alt]="'Firma asociada al estado ' + event.estado"
                                            class="img-fluid rounded border">
                                    </div>
                                </div>
                                }
                            </div>
                            @if (event.latitude != null && event.longitude != null) {
                            <div class="row g-3 mt-3">
                                <div class="col-12">
                                    <div class="border rounded p-3 h-100 bg-light-subtle">
                                        <div class="fw-semibold mb-2">Ubicacion GPS</div>
                                        <div class="small text-muted mb-2">
                                            {{ event.latitude }}, {{ event.longitude }}
                                        </div>
                                        @if (googleMapsUrl(event.latitude, event.longitude); as mapsUrl) {
                                        <a class="btn btn-sm btn-outline-primary" [href]="mapsUrl" target="_blank"
                                            rel="noopener noreferrer">
                                            Ver en Google Maps
                                        </a>
                                        }
                                    </div>
                                </div>
                            </div>
                            }
                        </details>
                    </td>
                </tr>
                }
                }
            </tbody>
            }
        </table>

    </div>